import { render, staticRenderFns } from "./TqTabs.vue?vue&type=template&id=6e9d8f60&scoped=true&"
import script from "./TqTabs.vue?vue&type=script&lang=js&"
export * from "./TqTabs.vue?vue&type=script&lang=js&"
import style0 from "./TqTabs.vue?vue&type=style&index=0&id=6e9d8f60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9d8f60",
  null
  
)

export default component.exports